import { emitOnce } from '..';

export const processBatch = async <T>(
  data: T[],
  batchSize: number,
  processItem: (item: T) => void
): Promise<void> => {
  for (let i = 0; i < data.length; i += batchSize) {
    const batch = data.slice(i, i + batchSize);

    emitOnce(() => {
      batch.forEach(processItem);
    });

    await new Promise((resolve) => setTimeout(resolve, 50));
  }
};
